import { render, staticRenderFns } from "./VehicleType.vue?vue&type=template&id=3a6ce8b0"
import script from "./VehicleType.vue?vue&type=script&lang=js"
export * from "./VehicleType.vue?vue&type=script&lang=js"
import style0 from "./VehicleType.vue?vue&type=style&index=0&id=3a6ce8b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports